export const EXPORT_RECIPIENT_DRAWER_LOADING_STATES = {
    EXPORT_RECIPIENT_FORMS_LOADING: "EXPORT_RECIPIENT_FORMS_LOADING",
    EXPORT_RECIPIENT_FORMS_READY: "EXPORT_RECIPIENT_FORMS_READY",
    EXPORT_ALL_RECIPIENTS_LOADING: "EXPORT_ALL_RECIPIENTS_LOADING",
    EXPORT_ALL_RECIPIENTS_READY: "EXPORT_ALL_RECIPIENTS_READY",
    EXPORT_SELECTED_RECIPIENTS_LOADING: "EXPORT_SELECTED_RECIPIENTS_LOADING",
    EXPORT_SELECTED_RECIPIENTS_READY: "EXPORT_SELECTED_RECIPIENTS_READY",
}

export const EXPORT_RECIPIENT_DRAWER_MESSAGE_MAP = {}